import React from 'react';
import Loading from '../../Loading.js';
import html2canvas from 'html2canvas';
var _ = require('underscore')
import './startingHandChart.css'
class StartingHandChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    displayCards = (rown) => {
        let index = -1
            , cells = []
            , cellVal = ''
            , sameSuit = false
            , idealHands = this.props.hands[this.props.position]
            , cards = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2']
            , holeCards = this.props.holeCards && Object.keys(this.props.holeCards).length > 0 && [...this.props.holeCards];

        cells = _.range(1, 14).map((i) => {
            let style = ''
            if (cards[i - 1] == cards[rown - 1]) {
                sameSuit = true
                cellVal = cards[rown - 1] + '' + cards[i - 1]
            }
            else if (sameSuit)
                cellVal = cards[rown - 1] + '' + cards[i - 1] + "s"
            else
                cellVal = cards[i - 1] + '' + cards[rown - 1] + "o"
            if (this.props.preFlopAggression) {
                index = this.props.missionHands.findIndex(handObj => handObj.cards === cellVal);
                if (this.props.missionHands[index])
                    if (this.props.missionHands[index] && this.props.missionHands[index].raised && this.props.missionHands[index].raised === 1)
                        style = `preFloAggRaise`
                    else if (this.props.missionHands[index] && this.props.missionHands[index].limp && this.props.missionHands[index].limp === 1)
                        style = `prefloAggCall`
            } else {
                if (idealHands.hasOwnProperty(cellVal) && idealHands[cellVal] == 'Yes') {
                    if (this.props.play == 'ideal') {
                        style = `startingHandIdealPlay`
                    } else if (this.props.play == 'actual') {
                        style = `startingHandActualPlay`
                    }
                }
                if (this.props.play == 'actual' && Object.keys(holeCards).length > 0) {
                    index = holeCards.findIndex(holeCard => holeCard.cards === cellVal);
                    if (index != -1) {
                        if (idealHands[cellVal] == 'Yes')
                            style = `startingHandIdealPlay`
                        else if (idealHands[cellVal] == 'No')
                            style = `startingHandActualWrongPlay`
                    }
                }
            }
            return (<td className={`tableData ${style}`}>{cellVal}</td>)
        });
        return cells
    }

    render() {
        let { play, holeCards, missionHands, totalHandPlayed } = this.props
        return (
            <table className="landingPageChart">
                <tbody>
                    {_.range(1, 14).map(r => <tr> {this.displayCards(r).map(card => card)} </tr>)}
                </tbody>
                {totalHandPlayed === 0 && play != 'ideal' &&
                    <div className="startingHand0Hands">Your hands will appear here when you play</div>}
            </table>
        )
    }
}

export default StartingHandChart


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/StartingHandChart.js
 **/